module.exports = __webpack_public_path__ + "static/media/logo-white.3d8e9c54.svg";